/**
 * Météo d'un projet (`green|amber|red|unknown`) : clé de libellé et classe de couleur, partagées
 * par le tableau de bord et la vue d'ensemble. Une valeur inconnue retombe sur `unknown`, jamais
 * sur la chaîne « undefined » dans une classe.
 */

// t('overview.weather.green') t('overview.weather.amber') t('overview.weather.red') t('overview.weather.unknown')
const WEATHER_KEYS = {
  green: 'overview.weather.green',
  amber: 'overview.weather.amber',
  red: 'overview.weather.red',
  unknown: 'overview.weather.unknown',
};

const WEATHER_CLASSES = {
  green: 'text-statut-ok',
  amber: 'text-statut-alerte',
  red: 'text-statut-erreur',
  unknown: 'text-ink-faint',
};

const known = (weather) => (Object.hasOwn(WEATHER_KEYS, weather) ? weather : 'unknown');

export const weatherKey = (weather) => WEATHER_KEYS[known(weather)];
export const weatherClass = (weather) => WEATHER_CLASSES[known(weather)];
